import React, {FC, useState} from "react";
import {Broadcast, Team, useApiCall} from "../../../lib/src/api";
import {useToasts} from "../../../lib/src/toasts/toasts";
import {config} from "../config";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faCheckCircle, faSquareCheck, faWarning} from "@fortawesome/free-solid-svg-icons";
import {faCircle} from "@fortawesome/pro-regular-svg-icons";
import {Callout} from "../../../lib/src/components/content/Callout";
import {BroadcastTeamSelect} from "../pages/broadcasts/BroadcastCreatePage";
import {ModalFooter} from "@jane/lib/src/components/layout/ModalProvider";
import {faSquare} from "@fortawesome/free-regular-svg-icons";
import {Select} from "../../../lib/src/components/form/Select";
import {LimitFilter, limitFilterOptions} from "../../../lib/src/api/repositories/broadcast-repository";

export const EditBroadcastTargetModal: FC<{ broadcast: Broadcast, teams: Team[], onFinished: () => void }> = (props) => {
  const { broadcasts } = useApiCall(config)
  const [targetType, setTargetType] = React.useState<"employees"|"clients">(props.broadcast.target_type)
  const [targetTeamId, setTargetTeamId] = React.useState<number|null>(props.broadcast.target_team_id)

  const [limitToGroup, setLimitToGroup] = useState<boolean>(props.broadcast.limit_filter !== 'all')
  const [limitFilter, setLimitFilter] = useState<LimitFilter>(props.broadcast.limit_filter ?? 'all')

  const {showToast} = useToasts()
  const submit = async () => {
    if (! targetTeamId) {
      return;
    }
    await broadcasts.update(props.broadcast.id, {
      target_type: targetType,
      target_team_id: targetTeamId,
      limit_filter: limitFilter
    }).catch(() => {
      showToast('Oeps', 'Er is iets misgegaan bij het bewerken.')
    })
    props.onFinished()
  }

  return <div className={''}>
    <div className={'flex flex-col space-y-3'}>
      <div className={"grid grid-cols-2 gap-4"}>
        <label className={`border flex items-center border-brand-primary border-opacity-30 ${targetType === "employees" ? 'bg-brand-primary text-brand-on-primary' : ''} cursor-pointer px-3 py-2 rounded-full`}>
          <input type="radio" className={'hidden'} name={"targetType"} value={"employees"} checked={targetType === "employees"} onChange={() => {setTargetType('employees'); }} />
          <FontAwesomeIcon icon={targetType === "employees" ? faCheckCircle : faCircle} className={'mr-2'} />
          Medewerkers
        </label>
        <label className={`border flex items-center border-brand-primary border-opacity-30 ${targetType === "clients" ? 'bg-brand-primary text-brand-on-primary' : ''} cursor-pointer px-3 py-2 rounded-full`}>
          <input type="radio" className={'hidden'} name={"targetType"} value={"clients"} checked={targetType === "clients"} onChange={() => {setTargetType('clients'); }} />
          <FontAwesomeIcon icon={targetType === "clients" ? faCheckCircle : faCircle} className={'mr-2'} />
          Cliënten
        </label>
      </div>
      <BroadcastTeamSelect teams={props.teams} value={targetTeamId} onChange={(team) => setTargetTeamId(team)} />
      {targetTeamId === null && <>
        <Callout color={'warning'} icon={faWarning}>Selecteer eerst een team om verder te gaan</Callout>
      </>}
      {targetType === 'employees' && <>
        {targetTeamId !== null && <div className={'flex flex-row space-x-4 items-center px-2 py-1 -mx-2 rounded-md hover:bg-brand-200 hover:cursor-default'}
                                       onClick={() => setLimitToGroup(!limitToGroup)}>
          <FontAwesomeIcon icon={limitToGroup ? faSquareCheck : faSquare} className={'text-brand-primary'}/>
          <div>Beperken tot groep</div>
        </div>}
        {limitToGroup && <div>
          <Select label={'Beperken tot:'} options={Object.entries(limitFilterOptions)} value={limitFilter} onChange={(e) => setLimitFilter(e as keyof typeof limitFilterOptions)} />
        </div>}
      </>}
    </div>
    <ModalFooter text={'Opslaan'} isDisabled={! targetTeamId} onSubmit={async () => {
      await submit()
      close()
    }} />
  </div>
}